import { ActionQueueItems } from './ActionQueue';
import { isLoopActive } from './ExecutionLoop';

export enum Priority {
    BACKGROUND,
    LOW,
    NORMAL,
    HIGH,
    CRITICAL,
    OVERRIDE,
}

/**
 * Display debugging information about {@link ActionQueue}, like queue lengths
 * and content, in the `console`.
 */
export function debug(): void {
    const queueLengths: Record<string, unknown> = {};
    [
        Priority.BACKGROUND,
        Priority.LOW,
        Priority.NORMAL,
        Priority.HIGH,
        Priority.CRITICAL,
        Priority.OVERRIDE,
    ].forEach((p) => {
        queueLengths[Priority[p]] = {
            queueLength: ActionQueueItems[p].length,
            queue: ActionQueueItems[p],
        };
    });
    console.table(queueLengths);
    console.log(`The queue's execution loop is ${isLoopActive() ? 'active' : 'waiting'}.`);
}
